import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

function getCookie(name) {
  let val = null;
  if (document.cookie && document.cookie !== '') {
    for (const cookie of document.cookie.split(';')) {
      const c = cookie.trim();
      if (c.startsWith(name + '=')) {
        val = decodeURIComponent(c.substring(name.length + 1));
        break;
      }
    }
  }
  return val;
}

let csrfFetched = false;

export const initCSRF = async () => {
  if (!csrfFetched) {
    try {
      await api.get('/csrf/');
      csrfFetched = true;
    } catch (e) {
      console.error('CSRF fetch failed:', e);
    }
  }
};

api.interceptors.request.use(async (config) => {
  if (!csrfFetched && config.method !== 'get') await initCSRF();
  const token = getCookie('csrftoken');
  if (token) config.headers['X-CSRFToken'] = token;
  return config;
});

// Faculty / Section / Service
export const getFaculties = () => api.get('/faculties/');
export const getSections = (facultyId) => api.get('/sections/', { params: facultyId ? { faculty: facultyId } : {} });
export const getServices = (sectionId, facultyId) => {
  const params = {};
  if (sectionId) params.section = sectionId;
  if (facultyId) params.faculty = facultyId;
  return api.get('/services/', { params });
};

// Tickets
export const createTicket = (data) => api.post('/tickets/', data);
export const getTickets = (params) => api.get('/tickets/', { params });
export const getTicket = (id) => api.get(`/tickets/${id}/`);
export const markTicketScanned = (id) => api.post(`/tickets/${id}/mark_scanned/`);
export const callNextTicket = (id) => api.post(`/tickets/${id}/call_next/`);
export const startServingTicket = (id) => api.post(`/tickets/${id}/start_serving/`);
export const completeTicket = (id, notes) => api.post(`/tickets/${id}/complete/`, { notes });
export const cancelTicket = (id) => api.post(`/tickets/${id}/cancel_ticket/`);
export const getNextWaitingTicket = () => api.get('/tickets/next_waiting/');
export const getTicketStats = (facultyId) => api.get('/tickets/stats/', { params: facultyId ? { faculty: facultyId } : {} });

// Auth
export const login = (username, password) => api.post('/auth/login/', { username, password });
export const logout = () => api.post('/auth/logout/');
export const getCurrentUser = () => api.get('/auth/me/');

// WebSocket
export const createWebSocket = (facultyId, type = 'queue') => {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = process.env.REACT_APP_WS_URL || window.location.host;
  return new WebSocket(`${proto}//${host}/ws/${type}/${facultyId}/`);
};

export default api;
